import { useMemo } from 'react';
import { GRID_CONFIG } from '../constants/grid';
import { useResponsiveView } from './useResponsiveView';

type GridContentType = 'regular' | 'shorts';

export function useGridLayout(type: GridContentType) {
  const { isMobile } = useResponsiveView();
  
  return useMemo(() => {
    const config = type === 'shorts' ? GRID_CONFIG.content.shorts : GRID_CONFIG.content.video;
    
    // For shorts on mobile, ensure we use a fixed column count instead of auto-fill
    // This ensures consistent behavior across different mobile browsers
    const gridTemplateColumns = (type === 'shorts' && isMobile) 
      ? 'repeat(2, 1fr)' // Force exactly 2 columns on mobile for shorts
      : `repeat(auto-fill, minmax(${config.minWidth}px, 1fr))`;
    
    return {
      containerClass: 'w-full',
      gridClass: `grid gap-4 auto-rows-auto`,
      itemClass: `w-full`,
      gridStyle: {
        gridTemplateColumns,
        maxWidth: '100%',
      },
      thumbnailClass: 'w-full h-full',
      thumbnailContentClass: 'w-full h-full'
    };
  }, [type, isMobile]);
}

export function calculateOptimalLimit(
  type: GridContentType, 
  containerWidth: number,
  isInitialLoad = true
): number {
  const config = type === 'shorts' ? GRID_CONFIG.content.shorts : GRID_CONFIG.content.video;
  const effectiveWidth = containerWidth - (GRID_CONFIG.spacing * 2); // Account for container padding
  const columnsCount = Math.floor(effectiveWidth / (config.minWidth + GRID_CONFIG.spacing));
  return Math.max(1, columnsCount) * 4; // Always ensure full rows
} 